export default __webpack_public_path__ + "static/media/Vogel-als-Prophet.161163f7.mp3";